<template>
  <v-layout row wrap>
    <v-flex xs6>
      <shop-view :shop=shop></shop-view>
    </v-flex>
    <v-flex xs6>
      <shop-form :shop=shop @onMessage='onMessage'></shop-form>
    </v-flex>
  </v-layout>
</template>

<script>
import ShopForm from '@/components/form/ShopForm.vue'
import ShopView from '@/components/card/ShopView.vue'

export default {
  name: 'EditShop',
  methods: {
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }
  },
  data () {
    return {
      shop: {}
    }
  },
  created () {
    this.shop = this.$route.params.shop
    console.log(this.shop)
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  components: {
    ShopForm,
    ShopView
  },
  head: {
    title () {
      return {
        inner: 'ショップ情報登録',
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: 'ショップ情報の登録ページ'}
      ]
    }
  }
}
</script>

<style scoped>
</style>